import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="container text-center mt-5">
      <h1 className="display-4 mb-4">مرحباً بك في نظام إدارة المشاتل الإلكتروني</h1>
      
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">روابط مهمة</h5>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  <Link to="/suppliers" className="text-decoration-none">الموردين</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/staff" className="text-decoration-none">الموظفين</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/categories" className="text-decoration-none">الفئات</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/products" className="text-decoration-none">المنتجات</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/customers" className="text-decoration-none">العملاء</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/customertypes" className="text-decoration-none">أنواع العملاء</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/fertilizers" className="text-decoration-none">الأسمدة</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/expenses" className="text-decoration-none">المصروفات</Link>
                </li>
                <li className="list-group-item">
                  <Link to="/staff/profile" className="text-decoration-none">الملف الشخصي</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;